import { createSelector } from 'reselect';
import { getInitialState } from './reducer';
export var selectPlatformDomain = function (state) {
    return (state && state.platform) || getInitialState();
};
export var selectPlatformWeb = createSelector(selectPlatformDomain, function (platform) { return ({
    loading: platform.loading,
    error: platform.error,
    subdomain: platform.subdomain,
    tempSubdomain: platform.tempSubdomain,
    hasSubdomain: platform.hasSubdomain,
    available: platform.available,
    webPublication_loading: platform.webPublication_loading,
    webPublication_error: platform.webPublication_error,
    webMeta: platform.webMeta,
    pwa_license: platform.pwa_license,
    revoke_loading: platform.revoke_loading,
    createLicense_loading: platform.createLicense_loading,
    has_license_loading: platform.has_license_loading,
}); });
export var selectPlatformPlayStore = createSelector(selectPlatformDomain, function (platform) { return ({
    check_loading: platform.check_loading,
    check_error: platform.check_error,
    androidBundleId: platform.androidBundleId,
    cert_loading: platform.cert_loading,
    cert_error: platform.cert_error,
    down_error: platform.down_error,
    cert: platform.cert,
    android_license: platform.android_license,
    createLicense_loading: platform.createLicense_loading,
    revoke_loading: platform.revoke_loading,
    has_license_loading: platform.has_license_loading,
}); });
export var selectPlatformAppStore = createSelector(selectPlatformDomain, function (platform) { return ({
    appStoreSecret_loading: platform.appStoreSecret_loading,
    appStoreSecret_error: platform.appStoreSecret_error,
    hasAppStoreSecret: platform.hasAppStoreSecret,
    appStoreSecretSave_loading: platform.appStoreSecretSave_loading,
    appStoreSecretSave_error: platform.appStoreSecretSave_error,
    iosBundle_loading: platform.iosBundle_loading,
    iosBundle_error: platform.iosBundle_error,
    iosBundleId: platform.iosBundleId,
    iosBundleCheckAppId: platform.iosBundleCheckAppId,
    iosTeamId: platform.iosTeamId,
    projectID: platform.projectID,
    ios_license: platform.ios_license,
    createLicense_loading: platform.createLicense_loading,
    revoke_loading: platform.revoke_loading,
    has_license_loading: platform.has_license_loading,
}); });
export var selectSubDomain = createSelector(selectPlatformDomain, function (platform) { return platform.subdomain; });
export var selectSubDomainAppId = createSelector(selectPlatformDomain, function (platform) { return platform.subdomainAppId; });
export var selectCertificateDetails = createSelector(selectPlatformDomain, function (platform) { return platform.certificateDetails; });
